import { useState } from 'react';
import { useAuthenticatedApi } from './useAuthenticatedApi';

interface ResetResult {
  status: string;
  message: string;
  commit_id: string;
  commit_short_id: string;
  commit_message: string;
  removed_commits: number;
  reset_to_date: string;
}

export const useResetToCommit = () => {
  const authenticatedApi = useAuthenticatedApi();
  const [resetting, setResetting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const resetToCommit = async (workspaceId: string, commitSha: string): Promise<ResetResult | null> => {
    setResetting(true);
    setError(null);

    try {
      const result = await authenticatedApi.post<ResetResult>(
        `/workspaces/${workspaceId}/reset-to-commit`,
        { commit_sha: commitSha }
      );
      return result;
    } catch (err: any) {
      const errorMessage = err.response?.data?.detail || err.message || 'Failed to reset to commit';
      setError(errorMessage);
      return null;
    } finally {
      setResetting(false);
    }
  };

  const clearError = () => setError(null);

  return { resetToCommit, resetting, error, clearError };
}; 